(function ($, Drupal, fwbPoints) {

    Drupal.behaviors.folwellResponsiveTables = {
        attach: function() {
            $.extend({
                responsiveTables: function(breakpoint) {
                    breakpoint = breakpoint || '800px';
                    if ($('table').length > 0) {
                        $('table').each(function(i) {
                            i++;
                            var className = 'jrt-instance-' + i;
                            var $this = $(this);
                            $this.addClass('jrt');
                            $this.addClass(className);
                            var styling =
                                '@media only screen and (max-width:' +
                                breakpoint +
                                ')  {\n';
                            if ($this.find('thead').length > 0) {
                                $this.find('thead th').each(function(i) {
                                    var $tdText = $(this)
                                        .text()
                                        .replace(/\s+/g, ' ');
                                    i++;
                                    styling +=
                                        '\t.' +
                                        className +
                                        '>tbody>tr>td.jrt-cell-' +
                                        i +
                                        ':before { content: "' +
                                        $tdText +
                                        '"; }\n';
                                });
                            }
                            $this.find('tbody > tr').each(function(i) {
                                var $this = $(this);
                                i++;
                                var arrColspan = [];
                                var modIndex = [];
                                $this.find('td,th').each(function(i, c, m) {
                                    var $this = $(this);
                                    i++;
                                    if (modIndex > 0) {
                                        modIndex[0];
                                        i++;
                                    }
                                    if (arrColspan > 0) {
                                        m = i + arrColspan.shift() - 1;
                                        modIndex.splice(0, 1);
                                        modIndex.push(m);
                                        i = m;
                                    }
                                    if ($this.is('[colspan]')) {
                                        c = parseInt($(this).prop('colspan'), 10);
                                        arrColspan.push(c);
                                    }
                                    $this.addClass('jrt-cell-' + i);
                                });
                            });
                            if ($this.find('thead').length > 0) {
                                styling += '}\n';
                                var styleElement = document.createElement('style');
                                styleElement.innerText = styling;
                                document.head.appendChild(styleElement);
                            }
                        });
                    }
                }
            });
            function setResponsiveCellHeight() {
              if (fwbPoints.matches('800px', true)) {
                const $cells = $('tr>td[class^=jrt-cell-]');
                $cells.each(function () {
                  $(this).css('height', 'auto');
                  const pseudoBeforeHeight = window.getComputedStyle($(this)[0], ':before').height;
                  if ($(this).height() < parseInt(pseudoBeforeHeight)) {
                    $(this).height(pseudoBeforeHeight);
                  }
                });
              }
            }

            var table = $('main table');
            table.find('thead th').attr({'scope': 'col', 'tabindex': '0' });
            table.find('td').attr('tabindex', '0');
            table.find('tbody th').attr({'scope': 'row', 'tabindex': '0' });
            $.responsiveTables();

            setResponsiveCellHeight();

            $(window).resize(function () {
              setResponsiveCellHeight();
            });
        }
    }

}(jQuery, Drupal, fwbPoints));
